import { useLocation } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { EventDeliveriesTabFallback } from '@/routes/webhook/tabs/event-deliveries/fallback'
import { OverviewTabFallback } from '@/routes/webhook/tabs/overview/fallback'

export const WebhookPageFallback = () => {
  const location = useLocation()

  if (location.pathname.includes('/overview')) {
    return <OverviewTabFallback />
  }

  if (location.pathname.includes('/event-deliveries')) {
    return <EventDeliveriesTabFallback />
  }

  return <CardSkeleton />
}
